import ViewWidget from './viewWidget'
export default ViewWidget
